import React, {Component, ReactNode} from 'react';
import {Button} from '@material-ui/core';
import './index.scss';

interface ToggleButtonProps {
  onChange?: (selected: boolean)=>void;
  selected?: boolean;
  allowDeselect?: boolean;
  className?: string;
  children: ReactNode;
}

interface ToggleButtonState {
  selected: boolean;
}

export default class ToggleButton extends Component<ToggleButtonProps, ToggleButtonState> {
  state = {
    selected: false
  };

  componentDidMount(): void {
    if(this.props.selected !== undefined) {
      this.setState({selected: this.props.selected});
    }
  }

  componentDidUpdate(prevProps: Readonly<ToggleButtonProps>, prevState: Readonly<ToggleButtonState>, snapshot?: any): void {
    const selected = this.props.selected;
    if(selected !== prevProps.selected && selected !== undefined && selected !== this.state.selected) {
      this.setState({selected: selected});
    }
  }

  onClick = () => {
    let selected = this.state.selected;
    if(selected && !this.props.allowDeselect) {
      return;
    }
    selected = !selected;
    this.setState({selected: selected});
    if(this.props.onChange) {
      this.props.onChange(selected);
    }
  };

  render() {
    let className = 'toggle-button';
    if(this.props.className) {
      className += ' ' + this.props.className;
    }
    if(this.state.selected) {
      className += ' selected';
    }
    return <Button className={className} onClick={this.onClick}>{ this.props.children }</Button>;
  }
}